import React from 'react';
import logo from "../images/ALL_ACCOR_PLUS_Logo_BLACK_Vertical.png";

class Header extends React.Component  {
    render() {
        const {bannerClass, bannerText} = this.props;

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between container my-3">
                    <img style={{ width: "115px" }} src={logo} alt="Accor Plus Logo" />
                </div>

                <div className="module mod-page-header theme-default theme-dark no-padding no-border">
                    <div className="component-image" data-autoload-component="image">
                        <div className={`${bannerClass}`}>
                            {bannerText && (
                                <h1 className="banner-text" dangerouslySetInnerHTML={{ __html: bannerText }} />
                            )}
                        </div>
                        <div className="overlay"></div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default (Header);